export default "__VITE_ASSET__S0KY9P7P__"